import { Button, Grid, TextField } from '@mui/material'
import React from 'react'
import MainCard from 'ui-component/cards/MainCard'
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useState } from 'react';
import StatusTable from './Components/LimitManagement/StatusTable';

const LimitManagement = () => {
    const [BankName, setBankName] = useState('');
    const [active,setActive]=useState(1)
    const [requestId,setRequestId]=useState(null);

    console.log(requestId);

    const handleChange = (event) => {
        setBankName(event.target.value);
    };

    const handleChangeFilter=(field,value)=>{
        if(field==='requestid'){
            setRequestId(value)
        }
    }



    return (
        <>
        <MainCard title="Admin request panel">
            <Grid container alignItems='center' justifyContent='left' spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                    <FormControl fullWidth size='small'>
                        <InputLabel id="demo-select-small-label">Bank</InputLabel>
                        <Select
                            labelid="demo-select-small-label"
                            id="demo-select-small"
                            value={BankName}
                            label="Bank"
                            onChange={handleChange}
                        >
                            <MenuItem value={10}>Ten</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                    <Button
                    variant={active===1?'contained':'outlined'}
                    fullWidth
                    onClick={()=>setActive(1)}
                    >
                        Upload Statement
                    </Button>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
                    <Button
                     variant={active===2?'contained':'outlined'}
                     fullWidth
                     onClick={()=>setActive(2)}
                     >
                        Update
                    </Button>
                </Grid>
            </Grid>

            <Grid container mt={2} gap={2} alignItems='center'>
                <Grid item xl={3}>
                    <TextField
                    label="Request ID"
                    onChange={(e)=>handleChangeFilter('requestid',e.target.value)}
                    fullWidth
                    />
                </Grid>
                <Grid item xl={3}>
                    <TextField
                    label="Agent Code"
                    onChange={(e)=>handleChangeFilter('requestid',e.target.value)}
                    fullWidth
                    />
                </Grid>
                <Grid item xl={3}>
                    <TextField
                    label="Beneficiary Bank"
                    onChange={(e)=>handleChangeFilter('requestid',e.target.value)}
                    fullWidth
                    />
                </Grid>
                <Grid item xl={2}>
                    <Button variant='contained'>Search</Button>
                </Grid>
            </Grid>

            <Grid container mt={2} gap={2}>
                <Grid item xl={3}>
                <TextField
                    label="Ledger from"
                    onChange={(e)=>handleChangeFilter('requestid',e.target.value)}
                    fullWidth
                    />
                </Grid>
                <Grid item xl={3}>
                <TextField
                    label="Ledger to"
                    onChange={(e)=>handleChangeFilter('requestid',e.target.value)}
                    fullWidth
                    />
                </Grid>
            </Grid>

        </MainCard>
        <MainCard sx={{marginTop:'20px'}}>
            <StatusTable/>
        </MainCard>
        </>
    )
}

export default LimitManagement
